export enum BathroomLocationOptions {
    UNKNOWN = 0,
    INSIDE = 1,
    OUTSIDE = 2
}
